export class FindAllApis {
  public static readonly type = '[Project/Api/List] FindAllApis';
}
